module.exports = __webpack_public_path__ + "static/primarycompositeendpoint_chart_mobile_2-acd7489e5f1874efed2dba6118fe6c43.png";